export default "__VITE_ASSET__Db7vYUYP__"